<template>
  <div class="content__box">
    <div>
      <img src="../assets/banaer.jpg" />
    </div>
    <div class="content__article">
      <div class="content__article-item">
        <h3><span>联系人:</span></h3>
        <div>
          <p>杜经理</p>
        </div>
      </div>
      <div class="content__article-item">
        <h3><span>联系QQ:</span></h3>
        <div>
          <p>369078192</p>
        </div>
      </div>
      <div class="content__article-item">
        <h3><span>联系邮箱：</span></h3>
        <div>
          <p>dubinggreate@163.com</p>
        </div>
      </div>
      <div class="content__article-item">
        <h3><span>联系微信：</span></h3>
        <div>
          <p><img src="../assets/weixin.png" /></p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/views/Footer";
export default {
  components: {
    Footer,
  },
  name: "Connect",
};
</script>

<style lang="less" scoped>
.content__box {
  height: 100%;
  overflow: auto;
}
.banner__box {
  background: url(https://www-file.huawei.com/-/media/corp2020/contact-us/contactus_banner_3.jpg)
    no-repeat;
  background-size: cover;
  // max-height: 590px;
  background-position: center center;
  min-height: 500px;
  width: 100%;
}

.content__article {
  width: 1200px;
  margin: auto;
  padding: 20px 0;
  .content__article-item {
    display: flex;
    justify-content: space-between;
    h3 {
      width: 200px;
      font-weight: 900;
      font-size: 30px;
      span {
        position: relative;
        padding-left: 10px;
        line-height: 30px;
      }
      span::before {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        content: "";
        width: 5px;
        height: 30px;
        background: #761a21;
      }
    }
    & > div {
      flex: 1;
      p {
        line-height: 30px;
      }
    }
  }
  .content__article-item + .content__article-item {
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Connect.vue